import { SET_INDEX_URLS } from "../action_types";

const initialUrls = ['#', '#', '#'];

const indexUrlsReducer = (urls = initialUrls, action) => {
    switch (action.type) {
        case SET_INDEX_URLS:

            if (!Array.isArray(action.urls)) {
                return urls;
            }
            
            for (let i = 0; i < 3; i++) {
                if (typeof action.urls[i] !== 'string') {
                    action.urls[i] = '#';
                } 
            }

            return action.urls;
        default:
            return urls;
    }
};

export default indexUrlsReducer;